<div class="card" *ngIf="viewModel$ | async as viewModel">
    <div class="p-grid p-ai-center">
        <div class="p-col">
            <span class="card-title">Similar Customers</span>
            <br>
            <small>Other customer profiles that share a name, email, or phone number with this customer.</small>
        </div>
        <div class="p-col p-text-right">
            <span class="p-input-icon-left">
                <i
                    *ngIf="!viewModel.loading"
                    class="pi pi-search"
                ></i>
                <i
                    *ngIf="viewModel.loading"
                    class="pi pi-spin pi-spinner"
                ></i>
                <input
                    type="text"
                    pInputText
                    [ngModel]="viewModel.search"
                    (ngModelChange)="store.dispatch(actions.searchInputChanged({ value: $event }))"
                    placeholder="Search by name, email, or phone"
                >
            </span>
        </div>
    </div>
    <hr>
    <p-table
        [value]="viewModel.rows"
        [loading]="viewModel.loading"
        dataKey="id"
        responsiveLayout="scroll"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th style="width: 7rem"></th>
                <th style="width: 3rem"></th>
            </tr>
        </ng-template>
        <ng-template
            pTemplate="body"
            let-similarCustomer
        >
            <tr [class.exact-match-row]="similarCustomer.isExactMatch">
                <td>
                    {{similarCustomer.givenName}} {{similarCustomer.familyName}}
                    <p-tag
                        *ngIf="similarCustomer.isExactMatch"
                        severity="warning"
                        value="Possible duplicate"
                        class="quick-margin"
                        [pTooltip]="'Name, email, and phone for this customer are identical to the customer you\'re currently viewing.'"
                        tooltipPosition="top"
                    ></p-tag>
                </td>
                <td>{{similarCustomer.email || 'None'}}</td>
                <td>{{similarCustomer | phone}}</td>
                <td>
                    <button
                        type="button"
                        pButton
                        label="Merge"
                        icon="pi pi-arrows-h"
                        class="p-button-outlined"
                        [disabled]="similarCustomer.mergeButtonDisabled"
                        [pTooltip]="similarCustomer.mergeButtonDisabledTooltip"
                        tooltipPosition="top"
                        (click)="store.dispatch(actions.mergeButtonClicked({ user: similarCustomer }))"
                    ></button>
                </td>
                <td><app-open-link [link]="'/user/'+similarCustomer.id"></app-open-link></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No similar customers found</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<app-user-page-merge-conflict-dialog></app-user-page-merge-conflict-dialog>
